import { render, staticRenderFns } from "./CompanyAttributes.vue?vue&type=template&id=ec57fd0c&scoped=true"
import script from "./CompanyAttributes.vue?vue&type=script&lang=js"
export * from "./CompanyAttributes.vue?vue&type=script&lang=js"
import style0 from "./CompanyAttributes.vue?vue&type=style&index=0&id=ec57fd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec57fd0c",
  null
  
)

export default component.exports